/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    Backdrop, Button, IconButton, Modal, withStyles,
} from '@material-ui/core';
import {
    bool, func, object, shape, string,
} from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import { setTokenLocalStorage } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const styles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalHeading: {
        fontWeight: 900,
        display: 'flex',
        justifyContent: 'center',
        fontSize: '20px',
        marginTop: '-15px',
    },
    subHeading: {
        fontSize: '16px',
        margin: '15px 0px 28px',
        lineHeight: '21px',
    },
    modalButtonContainer: {

        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    modalCancelButton: {
        width: '100%',
        borderRadius: '5px',
        color: 'white',
        backgroundColor: 'rgba(161, 0, 26, 1)',
        border: '1px solid rgba(161, 0, 26, 1)',
        padding: '7px !important',
        textTransform: 'capitalize',
        boxShadow: 'inherit',
        '&:hover': {
            backgroundColor: 'rgba(161, 0, 26, 1)',
            color: 'white',
            border: '1px solid rgba(161, 0, 26, 1)',
        },
    },
    modalCloseButton: {
        width: '100%',
        borderRadius: '5px',
        color: 'black',
        border: '1px solid black',
        padding: '7px !important',
        marginTop: '8px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: 'white',
            border: '1px solid black',
            color: 'black',
        },
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '24px',
        outline: 'none',
        maxWidth: '500px',
        width: '90%',
        borderRadius: '5px',
    },
    closeButton: {
        padding: '0px',
        justifyContent: 'flex-end',
        width: '100%',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
});
const AutoRenewalModal = ({
    classes, closeModal, open, userDetails, updateAutoRenewal, setAutoRenewal, setShowModal, trackAutoRenewEvent,
}) => {
    const trackOverlayCloseEvent = () => {
        trackAutoRenewEvent({
            eventCategory: 'account',
            eventAction: 'overlay exited',
            eventLabel: 'passport',
        });
        setAutoRenewal({
            checked: true,
        });
        setShowModal(false);
    };

    const cancelAutoRenew = () => {
        updateAutoRenewal({ emailId: userDetails.email, autoRenewFlag: false });
        setAutoRenewal({ checked: false });
        setShowModal(false);
        trackAutoRenewEvent({
            eventCategory: 'account',
            eventAction: 'pp auto renewal cancelled',
            eventLabel: 'passport',
            eventValue: 1,
        });
        setTokenLocalStorage(true, 'refreshMetadata');
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => trackOverlayCloseEvent()}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <div className={classes.paper}>
                <IconButton data-testid="close-button" className={classes.closeButton} aria-label="close"  onClick={() => closeModal()}>
                    <CloseIcon />
                </IconButton>
                <p className={classes.modalHeading}>Turn off Auto-Renewal?</p>
                <p className={classes.subHeading}>Your membership will remain active until the end of your current term, then expire. You can turn Auto-Renewal back on before then if you change your mind.</p>
                <div className={classes.modalButtonContainer}>
                    <Button variant="contained" data-testid="cancel-btn-test" color="primary" className={classes.modalCancelButton} onClick={cancelAutoRenew}>
                        Turn Off Auto-Renewal
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.modalCloseButton}
                        onClick={() => closeModal()}
                    >
                        Leave Auto-Renewal On
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

AutoRenewalModal.propTypes = {
    classes: object,
    open: bool,
    userDetails: shape({
        renewalDate: string,
    }),
    closeModal: func,
    setShowModal: bool,
    setAutoRenewal: object,
    updateAutoRenewal: func,
    trackAutoRenewEvent: func.isRequired,
};

AutoRenewalModal.defaultProps = {
    classes: {},
    open: false,
    userDetails: {
        renewalDate: '',
    },
    closeModal: () => { },
    setShowModal: false,
    setAutoRenewal: {},
    updateAutoRenewal: () => { },
};

export default withStyles(styles)(AutoRenewalModal);
